var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGuarantee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#9B51E0",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.77609 17.9309C9.86729 17.9772 9.96926 18.0008 10.0712 18C10.1732 17.9992 10.2744 17.9749 10.3664 17.9278L13.3047 16.402C14.1379 15.9705 14.7904 15.4881 15.2994 14.9264C16.4062 13.7026 17.0106 12.1407 16.9999 10.5301L16.965 5.21759C16.9617 4.60569 16.548 4.05969 15.9361 3.86122L10.47 2.07965C10.1409 1.97139 9.78023 1.97375 9.45689 2.08514L4.0115 3.93025C3.40295 4.13657 2.9967 4.68649 3.00002 5.29918L3.03484 10.6078C3.04562 12.2207 3.67075 13.7755 4.79581 14.9868C5.30984 15.5406 5.96813 16.016 6.81047 16.4404L9.77609 17.9309ZM8.99331 11.6873C9.11602 11.8018 9.2752 11.8583 9.43438 11.8568C9.59357 11.856 9.75192 11.7979 9.87297 11.6818L13.084 8.60663C13.3253 8.37521 13.3228 8.00336 13.079 7.77508C12.8344 7.54679 12.4406 7.54836 12.1994 7.77979L9.42526 10.4361L8.28942 9.37543C8.04485 9.14714 7.65186 9.1495 7.40977 9.38092C7.16851 9.61234 7.171 9.98419 7.41557 10.2125L8.99331 11.6873Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuarantee);
export default ForwardRef;